import React, { useEffect, useState } from 'react';
import { UserPlus } from 'lucide-react';
import { useData } from '../../App';
import { Button } from '../UI';
import { api } from '../../services/api';

// «Новые из lan-install»: монтажники/инженеры CRM без карточки в mb (обычно новые, без ИНН) — добавить как самозанятого,
// связать с существующей карточкой или скрыть
export interface CrmUnlinked {
    id: string; employeeId: number; fio: string; position: string | null; inn: string | null; phone: string | null; hasBank: boolean;
    similar: { id: string; name: string; type: string; isSelfEmployed: boolean }[];
}

export const CrmNewEmployees: React.FC<{ onCreated: (counterpartyId: string) => void }> = ({ onCreated }) => {
    const { showNotification, refreshData } = useData();
    const [rows, setRows] = useState<CrmUnlinked[]>([]);
    const [busy, setBusy] = useState('');
    const load = () => api.crmUnlinked().then(setRows).catch(() => setRows([]));
    useEffect(() => { load(); }, []);
    const act = async (r: CrmUnlinked, action: 'create' | 'link' | 'ignore', counterpartyId?: string) => {
        setBusy(r.id);
        try {
            const res = await api.crmEmployeeAction(r.id, action, counterpartyId);
            showNotification(action === 'create' ? `${r.fio} — добавлен как самозанятый` : action === 'link' ? 'Связано с карточкой' : 'Скрыто', 'success');
            await load();
            if (action !== 'ignore') { refreshData(); if (action === 'create' && res.counterpartyId) onCreated(res.counterpartyId); }
        } catch (e: any) { showNotification(e?.message || 'Ошибка', 'error'); }
        finally { setBusy(''); }
    };
    if (!rows.length) return null;
    return (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm">
            <div className="font-semibold text-amber-900 flex items-center gap-2"><UserPlus size={16} /> Новые из lan-install ({rows.length})</div>
            <p className="text-xs text-amber-800 mb-2">Монтажники и инженеры CRM, которых нет в mb. Добавьте как самозанятого (данные из CRM, остальное — в карточке)
                или свяжите с существующей карточкой — тогда выплаты будут уходить в lan-install.</p>
            <div className="divide-y divide-amber-200">
                {rows.map(r => (
                    <div key={r.id} className="py-2 flex flex-wrap items-center gap-2">
                        <div className="flex-1 min-w-[14rem]">
                            <div className="font-medium">{r.fio} <span className="text-xs text-slate-500 font-normal">· {r.position}</span></div>
                            <div className="text-xs text-slate-500">{r.inn ? `ИНН ${r.inn}` : 'ИНН не указан'}{r.phone ? ` · ${r.phone}` : ''}{r.hasBank ? ' · реквизиты есть' : ''}</div>
                        </div>
                        <Button size="sm" disabled={busy === r.id} onClick={() => act(r, 'create')}>Добавить как самозанятого</Button>
                        {r.similar.map(s => (
                            <Button key={s.id} size="sm" variant="outline" disabled={busy === r.id} onClick={() => act(r, 'link', s.id)}
                                title="Связать сотрудника lan-install с этой карточкой (тип карточки не меняется)">
                                Связать с «{s.name}»{s.type === 'STAFF' ? ' (штат)' : s.isSelfEmployed ? ' (СЗ)' : ''}</Button>))}
                        <button className="text-xs text-slate-500 hover:text-slate-800 underline" disabled={busy === r.id} onClick={() => act(r, 'ignore')}>Скрыть</button>
                    </div>))}
            </div>
        </div>
    );
};
